<template>
  <service
    data-aos="fade"
    :image="image"
    :title="title"
  >
    <p>
      Are you struggling to find time to cook? Or do you simply want to enjoy the hassle-free
      benefits of nourishing plant-based and homemade food?
    </p>
    <p>
      As a personal chef, I create personalised menus suited to you and/or your family, keeping
      your dietary needs and preferences in mind. I will source the ingredients and come to your
      kitchen at a convenient time to prepare. Prepared food will be labelled with instructions
      on how best to store, heat and serve — and the kitchen will be cleaned before departure.
    </p>
    <p>
      I am available for half days or full days of cooking, depending on the number of dishes
      and servings you require.
    </p>
    <p>
      To discuss how we can work together on a plan that suits you and your family,
      please contact me at <a href="mailto:contact@chefnaturelle.com">contact@chefnaturelle.com</a>.
    </p>
  </service>
</template>

<script>
import Service from '@/components/Service'
import MetaInfoBuilder from '@/utils/social'

export default {
  components: {
    Service,
  },
  data: () => ({
    image: require(`@/assets/images/personal-chef-banner1.jpg?vuetify-preload`),
    title: 'Personal Chef',
  }),
  metaInfo() {
    return new MetaInfoBuilder()
      .description('Are you celebrating a birthday, hosting a dinner party in Hertford, Hertfordshire or surrounding'
        + ' area? I can help you create the perfect meal that suits your event.')
      .image(`${window.location.origin}${this.image.src}`)
      .title(this.title)
      .build()
  }
}
</script>

<style scoped>
</style>
